export enum SpatialFilterQueryType {
  AdmRegion = 'AdmRegion',
  Mun = 'Mun',
  Arrond = 'Arrond',
  CircFed = 'CircFed',
  CircProv = 'CircProv',
  DirReg = 'DirReg',
  MRC = 'MRC',
  RegTour = 'RegTour',
  RSS = 'RSS',
  RLS = 'RLS',
  CLSC = 'CLSC'
}

export enum SpatialFilterType {
  Predefined = 'Predefined',
  Polygon = 'Polygon',
  Point = 'Point'
}

export enum SpatialFilterItemType {
  Address = 'Address',
  Thematics = 'Thematics'
}
